// import { Amplify } from 'aws-amplify';
//import { Amplify } from 'aws-amplify';
import { QRCodeComponent } from 'angularx-qrcode';
import { ChartsModule } from './components/shared/charts/charts.module';
import { AuthModule } from './components/auth/auth.module';
import { AppLayoutModule } from './components/layout/app-layout.module';
import { WidgetModule } from './components/widget/widget.module';
import { MatCard, MatCardModule } from '@angular/material/card';
import { MatComponentsModule } from './mat-components.module';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { Gridster, GridsterItem } from 'angular-gridster2';
import { ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DataService } from './services/data.service'
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DashboardModule } from './components/dashboard/dashbaord.module';
import { SharedServicesModule } from './services/shared.services.module';
import { AgGridModule } from 'ag-grid-angular';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { FilterService } from './services/filter.service';
import { environment } from 'src/environments/environment';
import { MatDialogRef } from '@angular/material/dialog';
import { ConstantsService } from './services/constants.service';
import { NewFilterService } from './services/new-filter.service';
import { SpinnerService } from './services/spinner.service';
import { MyInterceptor } from './services/my.interceptor';
import { RequestDedupInterceptor } from './services/request-dedup.interceptor';
import { MatTabsModule } from '@angular/material/tabs';
import { ExcelExportService } from './services/excelExport.service';
import { NumberPipe } from './pipe/number.pipe';
import { SharedComponentModule } from './components/shared/shared.module';
import { CsvExportService } from './services/csvexport.service';
import { LoaderToastModuleModule } from './components/loader-toast-module/loader-toast-module.module';
import { NavigationService } from './services/navigation.service';
import { UserActivityService } from './services/useractivity.service';
import { DeviceDetectionService } from './services/detectipad.service';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { IdleService } from './services/idle.service';
import { RouterHandlerService } from './services/router-handler.service';
import { DynamicCustomTooltipService } from './services/dynamic-custom-tooltip.service';
import { GridStateService } from './services/grid-state.service';
import { MsalModule, MsalService, MsalRedirectComponent, MsalGuard, MsalInterceptor } from '@azure/msal-angular';
import { PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { FilterTextPipe } from './pipe/filter.pipe';
import { SignalRService } from './components/messenger/services/signalr-service';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { UserStorageService } from './services/user-storage.service';
import { RequestCancelService } from './services/request-cancel.service';
import { Amplify } from 'aws-amplify';
import { ActionGridService } from '../app/components/widget/action-grid/action-grid.service';

import { DirectModule } from './components/direct/direct.module';
import { FloatingChatbotComponent } from './components/floating-chatbot/floating-chatbot.component';
import { buildAmplifyConfig } from './services/amplify-config';
import 'aws-amplify/auth/enable-oauth-listener';

Amplify.configure(buildAmplifyConfig() as any);

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    FloatingChatbotComponent,
  ],
  imports: [
    BrowserModule,
    DragDropModule,
    QRCodeComponent,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    Gridster,
    GridsterItem,
    ReactiveFormsModule,
    MatComponentsModule,
    AuthModule,
    DashboardModule,
    DirectModule,
    WidgetModule,
    AppLayoutModule,
    SharedServicesModule.forRoot(),
    ChartsModule,
    AgGridModule,
    MatCardModule,
    MatTabsModule,
    SharedComponentModule,
    LoaderToastModuleModule,
    MsalModule.forRoot(
      new PublicClientApplication({
        auth: {
          clientId: environment.clientId || '1d5fa526-092f-480f-a900-617a80ada1c0',
          authority: 'https://login.microsoftonline.com/common',
          redirectUri: environment.redirectUri || 'http://localhost:4200',
        },
        cache: {
          cacheLocation: 'sessionStorage', // optional: keeps you logged in across reloads
          storeAuthStateInCookie: true,  // optional: useful for IE/Edge
        },
      }),
      { interactionType: InteractionType.Popup }, // 👈 Guard config uses Popup
      {
        interactionType: InteractionType.Popup,    // 👈 Interceptor config uses Popup
        protectedResourceMap: new Map([
          ['https://graph.microsoft.com/v1.0/me', ['User.Read']],
          ['https://graph.microsoft.com/v1.0/sendMail', ['Mail.Send']],
        ])
      }
    ),
    NgIdleKeepaliveModule.forRoot()
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: MyInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: RequestDedupInterceptor, multi: true },
    DataService,
    ExcelExportService,
    DatePipe,
    NumberPipe,
    CurrencyPipe,
    FilterTextPipe,
    FilterService,
    CsvExportService,
    NewFilterService,
    UserActivityService,
    NavigationService,
    DeviceDetectionService,
    SpinnerService,
    DynamicCustomTooltipService,
    { provide: MatDialogRef, useValue: {} },
    ConstantsService,
    IdleService,
    RouterHandlerService,
    GridStateService,
    MsalService,
    MsalGuard, {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    SignalRService,
    UserStorageService,
    RequestCancelService,
    ActionGridService
  ],
  exports: [
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
